import React from 'react';
import { ResponsiveLine } from '@nivo/line'


const LineChart = ({data, x, y, isDarkMode}) => {

  const LineData = [
    {
      id: y,
      data: data.map((row) => ({
        x: row[0], 
        y: row[1], 
      })),
    },
  ];

    const CustomTooltip = ({ point }) => {
    return (
      <div className={`px-3 py-2 rounded border ${
        isDarkMode 
          ? 'bg-slate-800 border-slate-600 text-slate-200' 
          : 'bg-white border-gray-300 text-gray-900'
      }`}>
        <strong>{x}: </strong>{point.data.xFormatted}<br/>
        <strong> {y}: </strong>{point.data.yFormatted}
      </div>
    );
    };

    const theme = {
      axis: {
        ticks: {
          text: {
            fill: isDarkMode ? '#cbd5e1' : '#374151',
          },
        },
        legend: {
          text: {
            fill: isDarkMode ? '#cbd5e1' : '#374151',
          },
        },
      },
      grid: {
        line: {
          stroke: isDarkMode ? '#334155' : '#e5e7eb',
        },
      },
    };

    return (
      <div className={LineData[0].data.length > 0 ? 'h-96' : 'h-20'}>
        <ResponsiveLine
        data={LineData}
        margin={{ top: 50, right: 40, bottom: 50, left: 70 }}
        xScale={{ type: 'point' }}
        yScale={{
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: true,
            reverse: false
        }}
        yFormat=" >-.2f"
        axisTop={null}
        axisRight={null}
        theme={theme}
        colors={isDarkMode ? '#60a5fa' : '#3182CE'}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: x,
            legendOffset: 36,
            legendPosition: 'middle'
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: y,
            legendOffset: -60,
            legendPosition: 'middle'
        }}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        useMesh={true}
        tooltip={CustomTooltip}
        />
      </div>
    );
  };
  export default LineChart;
  